import { FC } from "react";
import { Path, Svg } from "react-native-svg";

import { tSvgProps } from "../types";

const PdLinkedin: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 12 12" fill="none" {...props}>
    <Path
      d="M1.65218 2.97992C2.38977 2.97992 2.98771 2.38198 2.98771 1.64438C2.98771 0.906791 2.38977 0.308853 1.65218 0.308853C0.914587 0.308853 0.31665 0.906791 0.31665 1.64438C0.31665 2.38198 0.914587 2.97992 1.65218 2.97992Z"
      fill="currentColor"
    />
    <Path d="M2.93825 4.06818H0.31665V11.6362H2.93825V4.06818Z" fill="currentColor" />
    <Path
      d="M9.46749 4.06818C9.36857 4.06818 9.26964 4.06818 9.17071 4.06818H8.87393C7.98357 4.06818 6.99429 4.41442 6.59858 5.25531V4.11764H4.47162V11.6856H6.6975V7.38227C6.79643 6.68977 7.24161 5.99728 8.0825 6.04674C9.02232 5.99728 9.46749 6.88763 9.46749 7.67906V7.77799V11.7351H11.6439V6.7887V6.68977C11.6439 5.25531 10.7041 4.21657 9.46749 4.06818Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdLinkedin;
